<template>
  <div>
    <a-spin :spinning="isLoading">
      <br />
      <div class="grid grid-cols-6">
        <div class="col-span-6 mx-8">
          <a-form ref="advertisementForm" :model="form" layout="vertical" class="mt-10">
            <a-divider orientation="center">
              Edit User
            </a-divider>
            <a-row :gutter="20">
              <a-col :span="12">
                <a-form-item label="Email">
                  <a-input v-model:value="form.email" type="email" placeholder="Email" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="Password">
                  <a-input v-model:value="form.password" placeholder="Password" />
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>
      </div>
      <div class="mx-10">
        <router-link to="/customers">
          <a-button>Cancel</a-button>
        </router-link>
        <a-button type="primary" @click="onSubmit" style="margin-left: 10px;">Save</a-button>
      </div>
    </a-spin>
  </div>
</template>

<script>
export default {
  components: {},
  async mounted() {
    const data = await this.$store.dispatch(
      "GET_USER_BY_ID",
      this.$route.params.id
    );
    this.form = { ...this.form, ...data.data };
  },
  data() {
    return {
      isLoading: false,
      subindustries: null,
      mediaType: "drive",
      form: {
        email: null,
        password: null,
      },
    };
  },
  methods: {
    async onSubmit() {
      const email = this.form.email;
      console.log(email)
      if (email.includes('@')) {

        const { success } = await this.createUser();
        if (success) {
          this.$router.push("/customers");
        }
      } else
        window.alert('please input valid mail')
    },
    async onSubmitAndKeep() {
      const { success } = await this.createUser();
      if (success) {
        this.$router.go(0);
      }
    },
    async createUser() {
      this.isLoading = true;

      const user = await this.$store.dispatch("UPDATE_USER", this.form);
      this.$store.commit("SET_FILTERS", {});

      this.isLoading = false;
      return user;
    },
  },
};
</script>

<style>
.advertisements__new__actions button~button,
.advertisements__new__actions a~a,
.advertisements__new__actions a~button,
.advertisements__new__actions button~a {
  margin-left: 10px;
}

.custom_select--group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 10px;
}

.custom_select--group .ant-row.ant-form-item {
  margin-bottom: 0 !important;
}

input {
  border: 1px solid gray;
  padding: 4px 10px;
  width: 100%;
}
</style>
